import { Component, OnInit } from '@angular/core';
import { ClientNotificationService } from './data/client-nfs.service';
import { ClientNotification } from './data/client-nfs';
import { DeviceDetectorService } from 'ngx-device-detector';
import {Router} from '@angular/router';

@Component({
    selector: 'app-client-nfs-page',
    templateUrl: './client-nfs-page.component.html',
    styleUrls: ['./client-nfs-page.component.scss'],
    providers: [DeviceDetectorService]
})
export class ClientNfsPageComponent implements OnInit {
    clientNfs: ClientNotification[];
    totalRecords: number;

    loadingg: boolean;

    isMobile = false;

    constructor(
    public router: Router,
        protected clientNotificationService: ClientNotificationService,
        protected deviceDetectorService: DeviceDetectorService
    ) { }

    ngOnInit(): void {
        this.loadingg = true;
        this.getNfsLazy(0, 15);

        this.isMobile = this.deviceDetectorService.isMobile();
    }

    getNfs() {
        this.clientNotificationService.getClientNfs(0, 15).subscribe(clientNfs => {
            // this.clientNfs = [];
            this.clientNfs = clientNfs.content;
            this.loadingg = false;
        })
    }

    getNfsLazy(start, limit) {
        this.loadingg = true;

        this.clientNotificationService.getClientNfs(start, limit).subscribe(clientNfs => {

            this.clientNfs = clientNfs.content;

            this.totalRecords = clientNfs.totalElements;

            this.loadingg = false;
        })
    }

    dismissMsg(msgId: number) {
        const msgIndex = this.clientNfs.findIndex(msg => msg.id === msgId);

        if (msgIndex > -1) {
            this.clientNfs.splice(msgIndex, 1);
        }

    }

    deleteMsg(msgId: number) {
        const msgIndex = this.clientNfs.findIndex(msg => msg.id === msgId);

        if (msgIndex > -1) {
            this.clientNfs.splice(msgIndex, 1);
        }

    }
}
